var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "active-requisitions-table grid-x grid-padding-x grid-padding-y"
    },
    [
      _c("div", { staticClass: "cell shrink" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.searchTerm,
              expression: "searchTerm"
            }
          ],
          staticClass: "mb-0",
          attrs: { type: "text", placeholder: "Filter by name..." },
          domProps: { value: _vm.searchTerm },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.searchTerm = $event.target.value
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "cell small-12" }, [
        _c("table", { staticClass: "mb-4" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "tbody",
            _vm._l(_vm.filteredApplications, function(jobApplication) {
              return _c("tr", { key: jobApplication.id }, [
                _c("td", [_vm._v(_vm._s(jobApplication.user.first_name))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(jobApplication.user.last_name))]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    _vm._s(
                      jobApplication.user.baseline_score !== null
                        ? jobApplication.user.baseline_score
                            .satisfied_trait_count
                        : ""
                    )
                  )
                ]),
                _vm._v(" "),
                _c(
                  "td",
                  [
                    _vm._l(_vm.phases, function(phase, index) {
                      return [
                        jobApplication[phase] &&
                        jobApplication[phase] == "failed"
                          ? _c(
                              "span",
                              {
                                key: index,
                                staticClass: "badge",
                                staticStyle: { "margin-right": "5px" }
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t" +
                                    _vm._s(
                                      phase
                                        .replaceAll("_", " ")
                                        .replace("status", "")
                                    ) +
                                    "\n\t\t\t\t\t\t\t"
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    _vm._s(
                      jobApplication.job.requisition.person_specification.title
                    )
                  )
                ]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(jobApplication.fail_reason))]),
                _vm._v(" "),
                _c("td", [
                  _c(
                    "form",
                    {
                      staticStyle: { display: "inline-block" },
                      attrs: {
                        action:
                          "/recruiter/active-requisitions/restore/" +
                          jobApplication.id +
                          "/" +
                          _vm.requisition.id,
                        method: "POST"
                      }
                    },
                    [
                      _c("input", {
                        attrs: { type: "hidden", name: "_csrfToken" },
                        domProps: { value: _vm.csrfToken }
                      }),
                      _vm._v(" "),
                      _c(
                        "a",
                        { attrs: { href: "#" }, on: { click: _vm.restore } },
                        [_vm._v("Restore to Requisition")]
                      )
                    ]
                  ),
                  _vm._v("\n\t\t\t\t\t\t|\n\t\t\t\t\t\t"),
                  _c(
                    "form",
                    {
                      staticStyle: { display: "inline-block" },
                      attrs: {
                        action:
                          "/recruiter/active-requisitions/hard-fail/" +
                          jobApplication.id +
                          "/" +
                          _vm.requisition.id,
                        method: "POST"
                      }
                    },
                    [
                      _c("input", {
                        attrs: { type: "hidden", name: "_csrfToken" },
                        domProps: { value: _vm.csrfToken }
                      }),
                      _vm._v(" "),
                      _c(
                        "a",
                        { attrs: { href: "#" }, on: { click: _vm.hardFail } },
                        [_vm._v("Hard Fail")]
                      )
                    ]
                  ),
                  _vm._v("\n\t\t\t\t\t\t|\n\t\t\t\t\t\t"),
                  _c(
                    "a",
                    {
                      attrs: {
                        href:
                          "/admin/users/impersonate/" + jobApplication.user.id
                      }
                    },
                    [_vm._v("Impersonate")]
                  ),
                  _vm._v("\n\t\t\t\t\t\t|\n\t\t\t\t\t\t"),
                  _c(
                    "a",
                    {
                      attrs: { href: "javascript:void(0)" },
                      on: {
                        click: function($event) {
                          return _vm.toggleModal(jobApplication)
                        }
                      }
                    },
                    [_vm._v("Recycle")]
                  )
                ])
              ])
            }),
            0
          )
        ])
      ]),
      _vm._v(" "),
      _c("recycle-modal", {
        ref: "recycleModal",
        attrs: {
          "job-application": _vm.selectedJobApplication,
          "csrf-token": _vm.csrfToken,
          "requisition-id": _vm.requisition.id,
          from: "failBin"
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Name")]),
        _vm._v(" "),
        _c("th", [_vm._v("Surname")]),
        _vm._v(" "),
        _c("th", [_vm._v("Baseline Score")]),
        _vm._v(" "),
        _c("th", [_vm._v("Fail Step")]),
        _vm._v(" "),
        _c("th", [_vm._v("Requisition")]),
        _vm._v(" "),
        _c("th", [_vm._v("Fail Reason")]),
        _vm._v(" "),
        _c("th", [_vm._v("Action")])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4ec68349", { render: render, staticRenderFns: staticRenderFns })
  }
}